import request from '@/utils/request'
import { stringify } from 'qs'

export function getByName(params) {
  return request({
    url: `/descriptions/name?${stringify(params)}`,
    method: 'get',
  })
}
